import axiosInstance from '../axiosInstance';
import { getManagerRoutePath } from '../managerRouteUtil';

/**
 * Manager Dashboard Service
 * Routes dynamically based on role_id from localStorage user.role.id
 */

const dashboardService = {
  /**
   * Get dashboard data with organization details and stats
   */
  getDashboard: async () => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.get(`/${routePath}/dashboard`);
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard:', error);
      throw error;
    }
  },

  /**
   * Just the day-scoped Care Packages / Schedule card, for the dashboard's
   * Today / Tomorrow toggle — avoids re-fetching the whole dashboard.
   * @param {'today'|'tomorrow'} day
   */
  getSchedule: async (day = 'today') => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.get(`/${routePath}/dashboard/schedule`, { params: { day } });
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard schedule:', error);
      throw error;
    }
  },
};

export default dashboardService;
